import { faBell, faCog, faHome, faKey, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, IconButton, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MessageList from "./messages";
import DockContainer from "../../dock";
import { ContextGlobal } from "../../../context";
import { useContext, useEffect, useRef, useState } from "react";

const SideRight = ({ handleExit, handleDrawerClose }) => {
	const navigate = useNavigate();

	const { enterpriseData, logErrorsData, listPermissionsData } = useContext(ContextGlobal);
	const [logData, setLogData] = useState([]);
	const [countLog, setCountLog] = useState(0);

	useEffect(() => {
		setLogData(logErrorsData);
	}, [enterpriseData, logErrorsData]);

	useEffect(() => {
		setCountLog(Array.isArray(logData) ? logData.length : 0);
	}, [logData]);

	const handleOpenMessageAlert = () => {
		handleDrawerClose();
		window.dispatchEvent(new Event("MessageAlert"));
	};

	const handleOpenConfigurations = () => {
		handleDrawerClose();
		window.dispatchEvent(new Event("Configurations"));
	};

	return (
		<>
			<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
				{(listPermissionsData?.nome_funcionario || listPermissionsData?.nome) && (
					<Typography variant="body2" sx={{ mr: 1, display: { xs: "none", sm: "block" } }}>
						Olá, {listPermissionsData?.nome_funcionario || listPermissionsData?.nome}
					</Typography>
				)}
				{/* Botão para ativar as notificações */}
				{enterpriseData && (
					<IconButton color="inherit" onClick={() => handleOpenMessageAlert()}>
						<div className="relative">
							<div className="absolute top-[4px] right-[-8px] h-[16px] w-[16px] bg-red-400 rounded-full flex items-center justify-center text-[10px] text-white">
								{countLog}
							</div>
							<FontAwesomeIcon icon={faBell} size="xs" />
						</div>
					</IconButton>
				)}

				{/* Pagina Home */}
				<IconButton color="inherit" onClick={() => navigate("/")}>
					<FontAwesomeIcon icon={faHome} size="xs" />
				</IconButton>

				<IconButton color="inherit" onClick={handleExit}>
					<FontAwesomeIcon icon={faSignOutAlt} size="xs" />
				</IconButton>
			</Box>

			{/* Lista Notificações  */}
			<DockContainer ident="MessageAlert">
				<div className="opacity-100 !text-opacity-100 bg-white dark:bg-gray-900 text-black">
					<MessageList logData={logData} setLogData={setLogData} />
				</div>
			</DockContainer>
		</>
	);
};

export default SideRight;

/* <DockContainer ident="Configurations">
				<div className="opacity-100 !text-opacity-100 bg-white dark:bg-gray-900 text-black">
					<MessageList />
				</div>
			</DockContainer> */
